import React, {useEffect, useState} from 'react';
import PageHeader1 from '../../components/common/PageHeader1';
import EditButton from "../../components/common/EditButton";
import DeleteButton from "../../components/common/DeleteButton";
import apiClient from "../../utils/api";
import { toast } from 'react-toastify';

function ChargesList() {
    const [charges, setCharges] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchCharges = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get('accounts/charges', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setCharges(response.data.data);
        } catch (error) {
            console.error('Error:', error);
            toast.error(error.response?.data?.message || 'Failed to fetch charges');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCharges();
    }, []);

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this charge?')) {
            return;
        }
        
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.delete(`accounts/charges/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Charge deleted successfully');
            fetchCharges();
        } catch (error) {
            console.error('Error:', error);
            toast.error(error.response?.data?.message || 'Failed to delete charge');
        }
    };

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 
                    pagetitle='Charges Adjustment' 
                    righttitle='Add Charges' 
                    link='/accounts/charges-add' 
                    routebutton={true}
                    permission="charges.create"
                />
                <div className="row g-3 mb-3">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                {loading ? (
                                    <div className="text-center">Loading...</div>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-hover align-middle mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Valet Location</th>
                                                    <th>Parking Type</th>
                                                    <th>Rate Type</th>
                                                    <th>Rate/Hour</th>
                                                    <th>Grace Period</th>
                                                    <th>Min/Max Fee</th>
                                                    <th>Effective From</th>
                                                    <th>Status</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {charges.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="10" className="text-center">No charges found</td>
                                                    </tr>
                                                ) : (
                                                    charges.map((charge) => (
                                                        <tr key={charge.id}>
                                                            <td>#{charge.id}</td>
                                                            <td>{charge.location_name || 'N/A'}</td>
                                                            <td>
                                                                <span className={`badge ${charge.parking_type === 'VIP' ? 'bg-primary' : 'bg-secondary'}`}>
                                                                    {charge.parking_type}
                                                                </span>
                                                            </td>
                                                            <td>{charge.rate_type}</td>
                                                            <td>
                                                                {charge.rate_type === 'flat' 
                                                                    ? `QR${charge.rate_per_hour}` 
                                                                    : 'Hourly rates'}
                                                            </td>
                                                            <td>{charge.grace_period} mins</td>
                                                            <td>QR{charge.minimum_fee} / ${charge.maximum_fee}</td>
                                                            <td>{new Date(charge.effective_from).toLocaleDateString()}</td>
                                                            <td>
                                                                <span className={`badge ${charge.is_active ? 'bg-success' : 'bg-danger'}`}>
                                                                    {charge.is_active ? 'Active' : 'Inactive'}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <div className="btn-group">
                                                                    <EditButton
                                                                        permission="charges.edit"
                                                                        to={`/accounts/charges-edit/${charge.id}`}
                                                                    />
                                                                    <DeleteButton
                                                                        permission="charges.delete"
                                                                        onDelete={() => handleDelete(charge.id)}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChargesList;